import JustValidate from 'just-validate';
import IMask from 'imask';

document.addEventListener('DOMContentLoaded', () => {
	const phoneMask = new IMask(
		document.getElementById('phone'),
		{
			mask: '+{7}(000)000-00-00',
		});

	const applicantForm = document.getElementById('joinForm');

	async function sendData(data) {
		return fetch('contact_me.php', {
			method: 'POST',
			// headers: {'Content-Type': 'multipart/form-data'},
			body: data,
		});
	}

	function serializeForm(formNode) {
		return new FormData(formNode);
	}

	async function handleFormSubmit(event) {
		event.preventDefault();
		const data = serializeForm(applicantForm);
		const response = await sendData(data);
	}

	const validation = new JustValidate('#joinForm', {
		errorFieldCssClass: 'is-invalid',
	});

	validation
		.addField('#name', [
			{
				rule: 'required',
				errorMessage: 'Обязательное поле',
			},
		])
		.addField('#phone', [
			{
				rule: 'required',
				errorMessage: 'Обязательное поле',
			},
			{
				rule: 'minLength',
				value: 16,
				errorMessage: 'Некорректный номер телефона',
			},
		])
		.addField('#role', [
			{
				rule: 'required',
				errorMessage: 'Обязательное поле',
			},
		])
		.addField('#policy', [
			{
				rule: 'required',
				errorMessage: '',
			},
		])
		.addField('#organization', [
			{
				rule: 'required',
				errorMessage: 'Обязательное поле',
			},
		])
		.addField('#email', [
			{
				rule: 'required',
				errorMessage: 'Обязательное поле',
			},
			{
				rule: 'email',
				errorMessage: 'Некорректный email',
			},
		])
		.onSuccess(handleFormSubmit);
});
